import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers';
import { renderDatePickerLocaleText } from 'utils';
import { GridFilterInputValueProps } from '@mui/x-data-grid-premium';

const GridFilterDateInput = (props: GridFilterInputValueProps) => {
  const { item, applyValue } = props;

  const handleFilterChange = (newValue: unknown) => {
    applyValue({ ...item, value: newValue });
  };

  return (
    <DatePicker
      value={item.value ? dayjs(item.value) : null}
      localeText={renderDatePickerLocaleText()}
      slotProps={{
        textField: {
          fullWidth: true,
          size: 'small',
          variant: 'standard',
        },
        inputAdornment: {
          sx: {
            '& .MuiButtonBase-root': {
              marginRight: -1,
            },
          },
        },
      }}
      onChange={handleFilterChange}
    />
  );
};

export default GridFilterDateInput;
